// extracted by mini-css-extract-plugin
export var animateOnHover = "Button-module--animateOnHover--c2f32";
export var button = "Button-module--button--c17ef";
export var innerBottom = "Button-module--innerBottom--d4a40";
export var innerTop = "Button-module--innerTop--3460f";
export var word = "Button-module--word--a04d7";